import { dataTool } from "echarts";
import  request  from "../utils/request";
let base64 = require('js-base64').Base64;

// export function Login(data){
//     return request({
//         method:'POST',
//         url:'/nk/choose/user/login',
//         data:data,
//         // headers:{
//         //     Authorization:'Basic'+" "+base64.encode("lure-web-client_id:123456"),
           
//         // }
//     })
// } 
export function Caps(params){
    return request({
        method:'GET',
        url:'/nk/choose/user/verify',
        params:params
    })
} 
// 删除 /teach/deleteById/{id}
export function Dele(id){
	return request({
		url:'/teach/deleteById/'+id,
		method:'DELETE',
		
	})
}



// WEBPACK FOOTER //
// ./src/api/prod.js